module.exports = __webpack_public_path__ + "static/media/practice_bg1.f235d563.svg";